import { faCheck, faExclamation, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UpcomingPayroll } from '../../../../redux/types'
import { Colors } from '../../../../constants/colors'

interface StatusIconProps {
  upcomingPayroll: UpcomingPayroll
}

const StatusIcon = ({ upcomingPayroll }: StatusIconProps) => {
  let icon = undefined
  let color = undefined

  if (upcomingPayroll.payrollFileOverdue || upcomingPayroll.validationErrors?.length > 0) {
    icon = faExclamationTriangle
    color = Colors.rubel_700
  } else if (upcomingPayroll.payrollFileDue) {
    icon = faExclamation
    color = Colors.rubel_700
  } else if (upcomingPayroll.payrollFileSubmitted && (!upcomingPayroll.validationErrors || upcomingPayroll.validationErrors.length === 0)) {
    icon = faCheck
    color = Colors.dollar_900
  }

  return (
    <>
      {icon &&
        <FontAwesomeIcon
          icon={icon}
          size='3x'
          color={color}
        />
      }
    </>
  )
}

export default StatusIcon 